import React, { useCallback, useEffect } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import PrivateComponentLoadingPage from "../LoadingPage/PrivateComponentLoadingPage";
import PaymentsAppLayout from "../../Components/Molecules/PaymentsAppLayout";
import { useCustomerStore } from "../../Store/Customer";
import { useParams } from "react-router-dom";
import CustomerDetailRightCardArray from "./CustomerDetailRightCardArray";
import CustomerDetailLeftTables from "./CustomerDetailLeftTables";
import { useSettingsStore } from "../../Store/Settings";

const CustomerDetailPage: React.FC = () => {
  const { getCustomerDetails, customerDetailEntity } = useCustomerStore();
  const { getSettings } = useSettingsStore();
  const { getAccessTokenSilently } = useAuth0();
  const { id: customerID } = useParams();

  const refreshThings = useCallback(async () => {
    if (!customerID) {
      throw new Error(`Customer ID not found in URL ${window.location.href}`);
    }
    await getCustomerDetails(getAccessTokenSilently, customerID);
  }, [getCustomerDetails, getAccessTokenSilently, customerID]);

  useEffect(() => {
    getSettings(getAccessTokenSilently);
  }, [getAccessTokenSilently, getSettings]);

  useEffect(() => {
    refreshThings();
  }, [refreshThings]);

  return (
    <PaymentsAppLayout documentTitle={customerDetailEntity?.name}>
      <div className="grid grid-cols-3 gap-4">
        <CustomerDetailLeftTables />
        <CustomerDetailRightCardArray />
      </div>
    </PaymentsAppLayout>
  );
};

export default withAuthenticationRequired(CustomerDetailPage, {
  onRedirecting: () => <PrivateComponentLoadingPage />
});
